import { createAction } from 'redux-actions'
import { types } from './types'

export const setAnimatedLogoClosing = createAction(types.SET_ANIMATED_LOGO_OPENING)
export const setAnimatedLogoOpening = createAction(types.SET_ANIMATED_LOGO_CLOSING)
export const setHasNavigated = createAction(types.SET_HAS_NAVIGATED)
export const setInitialRoute = createAction(types.SET_INITIAL_ROUTE)
export const resetLogo = createAction(types.RESET_LOGO)
